export default "__VITE_ASSET__Cd50Z$im__"